import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

interface StatData {
  count: number;
  suffix: string;
  label: string;
}

const stats: StatData[] = [
  { count: 40, suffix: '+', label: 'Πρωτιές στο νομό Λέσβου' },
  { count: 2000, suffix: '+', label: 'Μαθητές μέχρι σήμερα' },
  { count: 9, suffix: '/10', label: 'Επιτυχόντες στη σχολή πρώτης επιλογής' },
];

function formatNumber(n: number): string {
  return n.toLocaleString('el-GR');
}

function AnimatedNumber({ count }: { count: number }) {
  const ref = useRef<HTMLSpanElement>(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated.current) {
            hasAnimated.current = true;
            const duration = 1400;
            const start = performance.now();

            const step = (now: number) => {
              const t = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - t, 3);
              el.textContent = formatNumber(Math.round(count * eased));
              if (t < 1) {
                requestAnimationFrame(step);
              } else {
                el.textContent = formatNumber(count);
              }
            };

            requestAnimationFrame(step);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [count]);

  return <span ref={ref}>0</span>;
}

export default function Stats() {
  return (
    <section className="stats" id="stats">
      <div className="wrap">
        <div className="lead">
          <p className="eyebrow paper">Τα αποτελέσματά μας</p>
          <h2>Πάνω από δεκαπέντε χρόνια επιτυχιών στη Λέσβο.</h2>
        </div>
        <div className="stat-grid">
          {stats.map((stat, i) => (
            <div className="stat" key={i}>
              <div className="num">
                <AnimatedNumber count={stat.count} />
                <span className="suf">{stat.suffix}</span>
              </div>
              <div className="lbl">{stat.label}</div>
            </div>
          ))}
        </div>
        <div className="stats-cta">
          <Link to="/epityhontes" className="btn btn-ghost">
            Δείτε τα ονόματα
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
